<div class="container-style mt-2">
  <app-custom-table [headers]="orderHeader" [data]="generalData" [previousFilters]="filters"
    (onFilterChange)="onFilterChange($event)" (onPageChange)="onPageChange($event)" (onRecover)="onRecover()"
    filterPersistentKey]="'orders-consultation'">
  </app-custom-table>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>